
import {config, request, objectSerial} from 'Utils';

// 获取个人信息
export function fetchProfile() {
	return request(`${config.server}/api/v1/dms/employee/empMessage`, {
		method: 'get'
	});
}

// 修改个人信息 
export function updateProfile(param) {
	return request(`${config.server}/api/v1/dms/employee/update`, {
		method: 'post',
		body: param
	});
}
//保存头像
export function saveImg(param){
	return request(`${config.server}/api/v1/dms/employee/updateImg`, {
		method: 'post',
		body: param
	});
}


// WEBPACK FOOTER //
// ./src/service/profile/index.js